import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthTokenRevoke } from '../endpoints'

type MutationParams = Parameters<typeof postAuthTokenRevoke>[0]

export const useAuthTokenRevokePostMutation = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthTokenRevoke,
    MutationParams
  >,
) => useMutationEndpoint(postAuthTokenRevoke, options)
